import urls from "../../../../global/constants/UrlConstants";
import { getCallParams, getNoAuthCallParams, makeCall } from "../../../../utils/service";

export async function getProjectDetails(payload: any) {
  try {
    const callParams = await getCallParams("GET");
    const params = new URLSearchParams({
      page: String(payload.pageNumber ?? 0),
      limit: String(payload.pageSize ?? 25),
      search: String(payload.search ?? ""),
      status: String(payload.status ?? ""),
      propertyPurpose: String(payload.propertyPurpose || ""),
    });
    const orgId = payload.organizationId;
    if (orgId && orgId !== "all" && orgId !== "*") {
      params.set("organizationId", String(orgId));
    }
    const response = await makeCall(
      `${urls.GETPROJECTLIST}?${params.toString()}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function changeStatusApi(status: any, id: any) {
  const payload = {
    _id: id,
    status: status,
  };
  try {
    const callParams = await getCallParams("PUT", payload);
    const response = await makeCall(urls.UPDATEPROJECTDETAILS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}


export async function getProjectIdDetail(id: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETPROJECTIDETAILS + id, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}


export async function savePopUpdata(data: any) {
  console.log(data)
  const payload = {
    project_id: data.project_id,
    type:data.type,
    uid:data.uid
  };
  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(urls.SAVEPROJECTUID, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function reorder(data: any) {
  try {
    const callParams = await getCallParams("POST", data);
    const response = await makeCall(urls.PROJECTREORDER, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}